module.exports = __webpack_public_path__ + "static/media/green_label_mobile.d1f11018.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/backgrounds/green_label_mobile.jpg
// module id = 520
// module chunks = 0